import { render, staticRenderFns } from "./GestaoCargaDetalhes.vue?vue&type=template&id=5e3052c5"
import script from "./GestaoCargaDetalhes.vue?vue&type=script&lang=js"
export * from "./GestaoCargaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports